import React from "react";
import { Navigate } from "react-router-dom";

const RoleBasedRedirect = ({ role }) => {
  switch (role) {
    case "ADMIN":
      return <Navigate to="/dashboard" replace />;
    case "AUTHORITY":
      return <Navigate to="/authority/dashboard" replace />;
    default:
      return <Navigate to="/login" replace />;
  }
};

export default RoleBasedRedirect;
